"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx, Fragment } from 'react/jsx-runtime';
import { DropdownUI } from '../../../../DropdownUI/index.mjs';
import { OptionsList } from '../../OptionsList.mjs';

function FormulasCategoryContent({ onOptionSelect }) {
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(DropdownUI.Panel, { children: /* @__PURE__ */ jsx(DropdownUI.List, { children: /* @__PURE__ */ jsx(OptionsList, { onOptionSelect }) }) }) });
}

export { FormulasCategoryContent };
